exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#login-page{height:100%;background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/Login/styles.scss
// module id = 845
// module chunks = 0